<script>
  let fuelWallet = null;
  let faucetToken = null;
  $: tokenBalance = 0;
  let loading = false;
  let sendLoading = false;
  let transactions = [];

  async function authenticate() {
    await import("https://unpkg.com/@fuel-js/wallet@latest/umd/fuel.umd.min.js");
    const wallet = new fuel.Wallet(null, { network: "rinkeby" });
    fuelWallet = wallet;
    faucetToken = fuel.constants.faucetToken;
  }

  async function requestTokens() {
    loading = true;
    await fuelWallet.faucet();
    tokenBalance = await fuelWallet.balance(faucetToken, { format: "ether" });
    loading = false;
  }

  async function sendTokens() {
    sendLoading = true;
    const tx = await fuelWallet.transfer(faucetToken, fuelWallet.address, "10", { units: "ether" });
    transactions = [tx.transactionId, ...transactions];
    tokenBalance = await fuelWallet.balance(faucetToken, { format: "ether" });
    sendLoading = false;
  }
</script>

<style>
  div {
    padding-top: 30px;
  }

  p {
    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Helvetica, Arial, sans-serif, Apple Color Emoji,
      Segoe UI Emoji;
    color: rgb(38, 40, 42);
    line-height: 1.8;
  }

  a {
    word-break: break-all;
    color: #029a78;
    border-bottom: 1px dashed #029a78;
    text-decoration: none;
    transition: 50ms ease-in-out;
  }

  a:hover {
    opacity: 0.8;
  }

  button {
    background-color: #029a78;
    width: 100%;
    color: white;
    padding: 10px 0px;
    border-radius: 5px;
    border: none;
    transition: 50ms ease-in-out;
    cursor: pointer;
    border: 2px solid #029a78;
  }

  button:hover {
    opacity: 0.8;
  }

  .info,
  .transactions {
    display: block;
    padding: 10px 10px;
    border-radius: 5px;
    border: 2px solid gray;
    margin: 10px 0px;
    text-align: center;
    color: gray;
  }

  .transactions {
    text-align: left;
  }

  .transactions > a {
    display: inline-block;
    width: calc(100% - 150px);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    vertical-align: top;
  }
</style>

<div>
  <h3>Wallet</h3>
  {#if !fuelWallet}
    <button on:click={authenticate}>Generate Wallet</button>
  {:else}
    <span class="info">Wallet:
      <a
        href={`https://rinkeby.fuel.sh/address/${fuelWallet.address}`}
        target="_blank"
        rel="noopener noreferrer">{fuelWallet.address}</a></span>
    <span class="info">Faucet Token Balance: {tokenBalance}</span>
    <button on:click={requestTokens}>
      {#if loading}<span>Requesting...</span>{:else}<span>Request Faucet Tokens</span>{/if}
    </button>
  {/if}
  <h3>Transactions</h3>
  {#if !fuelWallet}
    <p>Generate wallet to get started.</p>
  {:else if tokenBalance === 0}
    <p>Request Faucet Tokens to send transactions.</p>
  {:else}
    <button on:click={sendTokens}>{#if sendLoading}
        <span>Sending...</span>
      {:else}<span>Send yourself 10 tokens</span>{/if}</button>
    <div>
      {#each transactions as tx}
        <span class="transactions">Sent 10 tokens (tx:
          <a href={`https://rinkeby.fuel.sh/tx/${tx}`} target="_blank" rel="noopener noreferrer">{tx}</a>)</span>
      {/each}
    </div>
  {/if}
</div>
